(ns shared.core.keybind.views
  (:require [clojure.string :as s]
            [shared.core.components.tooltip :as tooltip]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.util :as util]
            [keybind.core :as kb]))

(defn keybind-text [{:keys [key style label-style keybind-style label]}]
  (let [key-parts (s/split key "-")]
    (into [:div {:style (merge {:display :flex
                                :align-items :center}
                               style)}]
          (concat (when label
                    [[:div {:style (merge {:color (style/color :white :base)
                                           :font-size 12
                                           :margin-right 5}
                                          label-style)}
                      label]])
                  (map-indexed (fn [idx k]
                                 (let [last? (= idx (dec (count key-parts)))]
                                   [:div {:style (merge {:background-color (style/color :gray :base)
                                                         :border-radius 2
                                                         :color (style/color :white :base)
                                                         :font-size 11
                                                         :display :flex
                                                         :align-items :center
                                                         :justify-content :center
                                                         :padding "2px 3px"
                                                         :margin-right (if last? 0 3)}
                                                        keybind-style)}
                                    (condp = k
                                      "defmod" (if (util/mac?) "⌘" "ctrl")
                                      "shift" "⇧"
                                      "esc" "esc"
                                      (s/upper-case k))]))
                               key-parts)))))

(defn keybind-text-cmp [{:keys [key keyword func]}
                        & contents]
  (re/create-class
    {:component-did-mount
     (fn [_]
       (kb/bind! key keyword func))
     :component-will-unmount
     (fn [_]
       (kb/unbind! key keyword))
     :reagent-render
     (fn [{:keys [tooltip-label tooltip-placement cmp-type cmp-args]}]
       ^{:key (pr-str cmp-args)}
       [tooltip/tooltip
        {:placement (or tooltip-placement :bottom)
         :tooltip-content [keybind-text {:key key
                                         :label tooltip-label}]
         :target-content (into [cmp-type cmp-args]
                               contents)}])}))
